import { useMessageGetter } from 'react-message-context';
import React from 'react';
import { parseMessageWithFormat } from '../utils/messages';

/**
 * Extended version of `useMessageGetter` which supports specific HTML tags.
 * Returns React nodes instead of raw text.
 */
export const useFormattedMessageGetter = (rootId: string) => {
  const getMessage = useMessageGetter(rootId);

  return (key: string, args?: Record<string, any>): React.ReactNode => {
    return parseMessageWithFormat(getMessage(key, args));
  };
};
